// extracted by mini-css-extract-plugin
export default {"container":"gp-z","ratingLayout":"hp-z","ratingLabel":"ip-z","nonInteractiveRatingLabel":"jp-z"};